module.exports = __webpack_public_path__ + "static/img/kanifa.37757ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/kanifa.jpg
// module id = 65
// module chunks = 1